import React, { Component } from 'react';
import __ from 'lodash';
import LoaderModal from '../../../../../modal/LoaderModal';
import Navbar from '../../../../navbar/Navbar';
import Sidebar from '../../../../sidebar/Sidebar';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../../actions';
import {CONFIG } from '../../../../../../config';
import accountManagement from '../../../../../../apis/accountManagement';
import {Row, Col, Alert} from 'react-bootstrap';
import { Link } from 'react-router-dom';

class ReportAsmDinasJadwal extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching : false,
            alertShow: false,
            resMessage: "message",
            listJenjang: [],
            listProfil: [],
            kodeJenjang: null,
            idProfilCbt: null
        }
    }

    async componentDidMount() {         
        this.setState({ isFetching: true});
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)) {            
            this.fetchJenjang();            
        } 
        this.setState({ isFetching: false});  
    }

    fetchJenjang = async () =>{
        this.setState({ isFetching: true, alertShow: false, listJenjang: [] });
        const response = await accountManagement.get(CONFIG.GET_JENJANG_DINDIK, {
            params: { idDinasPemda: this.props.account.idDinas }
            }).catch(function(error){ this.setState({ alertShow: true, resMessage: 'Error.. Please refresh...' }) })
        if(response){            
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listJenjang: response.data.data
                })
            }
            else {
                this.setState({ alertShow: true, resMessage: response.data.errorSchema.errorMessage})
            }
            this.setState({ isFetching: false});
        }
         
    }

    handleClick(e) { 
        
        if(this.state.idProfilCbt === null) {
            this.setState({ alertShow: true, resMessage: 'Silakan Pilih CBT...'})
            e.preventDefault();
        }   
        
    }

    handleOnChangeJenjang = async (e) => {
        console.log(e.target.value)
        const kodeJenjangSekolah = e.target.value;
        this.setState({ isFetching: true, alertShow: false, listProfil: [], idProfilCbt: null });
        const response = await accountManagement.get(CONFIG.GET_PROFIL_CBT_DINDIK, {
            params: { idDinasPemda: this.props.account.idDinas, kodeJenjangSekolah: kodeJenjangSekolah }
            }).catch(function(error){ this.setState({ alertShow: true, resMessage: 'Error.. Please refresh...' }) })
        if(response){           
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listProfil: response.data.data                    
                })
            }
            else {
                this.setState({ 
                    alertShow: true, resMessage: response.data.errorSchema.errorMessage
                })
            }
            this.setState({ isFetching: false, kodeJenjang: kodeJenjangSekolah});
        }        
    }

    handleOnChangeProfil = (e) => {
        this.setState({ isFetching: true});
        this.setState({ idProfilCbt: e.target.value});
        this.setState({ isFetching: false});

    }



    render() {
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Report Asesmen Nasional'}/> 
                    {this.loadAlert()}

                    <Row> 
                        <Col><select className="form-control" value={this.state.kodeJenjang || ''} onChange={this.handleOnChangeJenjang} required>
                                <option value="" selected disabled>~~ Pilih Jenjang ~~</option>
                                {this.state.listJenjang.map((data,i) =>
                                    <option key={i} value={data}>{data}</option>
                                )}                                
                            </select>
                        </Col>

                        <Col><select className="form-control" value={this.state.idProfilCbt || ''} onChange={this.handleOnChangeProfil} required>
                                <option value="" selected disabled>~~ Pilih CBT ~~</option>
                                {this.state.listProfil.map((data,i) =>
                                    <option key={i} value={data.idProfilCbt}>{data.namaProfil}</option>
                                )} 
                            </select>
                        </Col>
                    </Row>

                    <Row style={{marginTop:'25px'}}> 
                        <Col>
                            <Link to={{ pathname: '/asmdinasreport' 
                                +'/'+ this.state.idProfilCbt
                                +'/'+ this.props.account.idDinas
                                +'/'+ this.state.kodeJenjang}} 
                                target='_blank' onClick={(e) => this.handleClick(e)}>
                                <button className="btn btn-success" title="Generate Report...">Generate Report</button> 
                            </Link>
                        </Col>
                    </Row>
                    

                </div>
            </div>
        )
    }
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(ReportAsmDinasJadwal); 